import { useGetWorkspaceRulesQuery } from '@generated/graphql';
import { useEditRulesModal } from './EditRulesModal';
import { RulesCard } from './RulesCard';

type WorkspaceRulesCardProps = {
  workspaceId: string;
  startOpen?: boolean;
};

export const WorkspaceRulesCard = ({ workspaceId, startOpen = false }: WorkspaceRulesCardProps) => {
  const { data: workspaceRulesData } = useGetWorkspaceRulesQuery({
    variables: { workspaceId },
    skip: !workspaceId,
  });
  const workspaceRules = workspaceRulesData?.getWorkspaceRules || '';

  const { showEditRulesModal } = useEditRulesModal({
    componentProps: {
      workspaceId,
      reloadKey: 'workspace-edit-rules',
    },
    modalProps: {
      title: 'Edit workspace rules',
    },
  });
  const handleEdit = () => {
    showEditRulesModal({ currentRules: workspaceRules });
  };

  return (
    <RulesCard
      rules={workspaceRules}
      source="workspace"
      startOpen={startOpen}
      onEdit={handleEdit}
    />
  );
};
